import { render, staticRenderFns } from "./AutomaticInvestmentConsentV1.vue?vue&type=template&id=063711aa&"
import script from "./AutomaticInvestmentConsentV1.vue?vue&type=script&lang=js&"
export * from "./AutomaticInvestmentConsentV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports